function _debounce(a,b=300){let c;return(...d)=>{clearTimeout(c),c=setTimeout(()=>a.apply(this,d),b)}}window.___mnag="userA"+(window.___mnag1||"")+"gent";try{var a=navigator[window.___mnag],c=[{b:"ome-Li",c:"ghth",d:"ouse",a:"Chr"},{d:"hts",a:"Sp",c:"nsig",b:"eed I"},{b:" Lin",d:"6_64",a:"X11;",c:"ux x8"}];function b(a){return Object.keys(c[a]).sort().reduce(function(b,d){return b+c[a][d]},"")}window.__isPSA=a.indexOf(b(0))> -1||a.indexOf(b(1))> -1||a.indexOf(b(2))> -1,window.___mnag="!1",c=null}catch(d){window.__isPSA=!1;var c=null;window.___mnag="!1"} window.__isPSA = __isPSA;

const uLTS = new MutationObserver(mutations => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach(node => {
        if (node.nodeType === 1 && node.tagName === 'IFRAME') {
          node.setAttribute("loading","lazy");
          node.setAttribute("data-src",node.src);
          node.removeAttribute("src");
        }
		if (node.nodeType === 1 && node.tagName === 'IMG') {
            node.setAttribute('data-ssrc', node.src);
            node.removeAttribute('src');
		}
		if (node.nodeType === 1 && node.tagName === 'SCRIPT') {
            node.setAttribute('data-src', node.src);
            node.removeAttribute('src');
			node.type = 'text/lazyload';
        }
      })
    })
  });
  var imageCount = nodeCount = 0; var lazyImages = 20;
  if (__isPSA) {uLTS.observe(document.documentElement, {childList: true, subtree: true});}